'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavDivider", {
    enumerable: true,
    get: function() {
        return NavDivider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdivider = require("@fluentui/react-divider");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavDivider = require("./useNavDivider");
const _useNavDividerStylesstyles = require("./useNavDividerStyles.styles");
const NavDivider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavDivider.useNavDivider_unstable)(props, ref);
    (0, _useNavDividerStylesstyles.useNavDividerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavDividerStyles_unstable')(state);
    return (0, _reactdivider.renderDivider_unstable)(state);
});
NavDivider.displayName = 'NavDivider';
